import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { routeCountryPath } from "../../shared/utilities/common";
import { store } from "../../redux/store";

import legacyStyles from "./LoyaltyReward.module.css";
import brandStyles from "./LoyaltyRewardBrandRefresh.module.css";
import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import LoyaltyDeals from "./LoyaltyDeals";
import LoyaltyRedeem from "./LoyaltyRedeem";
import LoyaltyPointTracker from "./LoyaltyPointTracker";

import { PUNCHH } from "../../shared/constants/loyaltyType";
import { orderMethods } from "../../shared/constants/order";
import * as loyaltyRepo from "../../shared/repos/graphql/loyalty";
import { shippingNotAllowToLoyaltyProduct } from "../../shared/utilities/modals";

import * as loyaltyAction from '../../redux/actions/loyalty';
import * as addressActions from "../../redux/actions/address";
import * as elementsActions from "../../redux/actions/elements";

import DeliveryPickUpWidget from "../../components/DeliveryPickUpWidget/DeliveryPickUpWidget";
import CookieChallenge from "./CookieChallenge";


class LoyaltyReward extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDeliveryWidget: false,
      addressType: "Delivery",
      activeTab: "Challenge",
      hasChallenge: false,
      barcode: null,
      barcodeStatus: "loading",
    };
  }

  async componentDidMount() {
    const { history, activeLoyalty, setRedeemableItem } = this.props;

    if (activeLoyalty !== PUNCHH) {
      history.push(routeCountryPath("/"));
      return;
    }

    await this.getLoyaltyPoints();
    
    setRedeemableItem({
      redeemableType: null,
      redeemableId: null
    })
  }

  getLoyaltyPoints = async () => {
    if (!isBrandRefreshEnabled()) {
      const response = await loyaltyRepo.getLoyaltyProfile();
      this.getRemainingPointBalance(response?.data?.loyaltyProfile?.points);
      return;
    }
    this.setState({ barcodeStatus: "loading" });
    try {
      const response = await loyaltyRepo.getLoyaltyProfile();
      const profile = response?.data?.loyaltyProfile;
      if (Number.isFinite(profile?.points)) this.getRemainingPointBalance(profile.points);
      this.setState({
        barcode: profile?.qrCode || null,
        barcodeStatus: profile?.qrCode ? "ready" : "error"
      });
    } catch (error) {
      this.setState({ barcode: null, barcodeStatus: "error" });
    }
  };

  getRemainingPointBalance = (points) => {
    const { order } = this.props;
    let loyaltyPoints = points;
    if (order && order?.orderRedeemables?.length > 0) {
      const usedPoints = order?.orderRedeemables?.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.points;
      }, 0);

      loyaltyPoints = points - usedPoints;
    }

    store.dispatch(
      loyaltyAction.loyaltyPoints(loyaltyPoints)
    );
  }

  openDeliveryWidget = link => {
    const {
      userOrderMethod,
      setModalObject,
      userAddress,
      history,
      setRedirectUrl
    } = this.props;

    const shippingNotAllowedForLoyalty = userOrderMethod === orderMethods.shipping;
    if (shippingNotAllowedForLoyalty) {
      setModalObject(
        shippingNotAllowToLoyaltyProduct(() => {
          setRedirectUrl(link);
          this.setState({
            showDeliveryWidget: true
          });
        }, this.onCloseWidget)
      );
    } else if (!userAddress) {
      setRedirectUrl(link);
      this.setState({
        showDeliveryWidget: true
      });
    } else {
      history.push(link);
    }
  };

  onCloseWidget = () => {
    this.setState({
      showDeliveryWidget: false
    });
  };

  setActiveTab = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleChallengeLoaded = (hasChallenge) => {
    this.setState({ hasChallenge, activeTab: hasChallenge ? "Challenge" : "Rewards" });
  };

  renderTabs = () => {
    const { activeTab } = this.state;
    const brandRefresh = isBrandRefreshEnabled();
    const styles = brandRefresh ? brandStyles : legacyStyles;
    const activeClass = tab => (activeTab === tab ? styles.activeTab : "");
    return (
      <div className={brandRefresh ? styles.tabs : "font-montserratBold text-white"}>
        <ul className="flex flex-wrap -mb-px justify-center">
          {["Challenge", "Rewards"].map((tab) => (
            <li
              key={tab}
              className={brandRefresh ? activeClass(tab) : `me-2 border-b-2 border-transparent rounded-t-lg hover:text-dryPink hover:border-dryPink/50 ${activeTab === tab ? "text-dryPink border-dryPink font-semibold" : ""}`}
            >
              <button
                type="button"
                onClick={() => this.setActiveTab(tab)}
                tabIndex={0}
                onKeyDown={!brandRefresh ? e => {
                  if (e.key === "Enter") this.setActiveTab(tab);
                } : undefined}
                aria-pressed={brandRefresh ? activeTab === tab : undefined}
                className="inline-block p-4"
              >
                {tab}
              </button>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const brandRefresh = isBrandRefreshEnabled();
    const styles = brandRefresh ? brandStyles : legacyStyles;
    const { showDeliveryWidget, addressType, activeTab, hasChallenge, barcode, barcodeStatus } = this.state;

    const { loyaltyPoints, loyaltyRedeemables, setRedeemableItem, platformWalletLoyaltyCardFeature } = this.props;
    return (
      <div className={brandRefresh && activeTab === "Rewards" ? `${styles.pageWrapper} ${brandStyles.rewardsContentWrapper}` : styles.pageWrapper}>
        {hasChallenge && (this.renderTabs())}
        {activeTab === 'Challenge' && (
          <div className='py-4 content-center min-h-screen'>
            <CookieChallenge brandRefresh={brandRefresh} variant="detailed" onChallengeLoaded={this.handleChallengeLoaded}  />
          </div>
        )}
        {activeTab === 'Rewards'  && (
          <>
            <div className={`${styles.topContainer} ${brandRefresh ? "" : "py-4 content-center"}`}>
              <LoyaltyPointTracker
                brandRefresh={brandRefresh}
                points={loyaltyPoints}
                redeemables={loyaltyRedeemables}
                barcode={barcode}
                barcodeStatus={barcodeStatus}
                onRetryBarcode={this.getLoyaltyPoints}
                walletEnabled={platformWalletLoyaltyCardFeature}
              />
            </div>
            <div
              className={brandRefresh ? styles.pageContainer : `${styles.pageContainer} w-full mx-auto py-12 flex flex-col gap-6`}
            >
              <LoyaltyDeals
                points={loyaltyPoints}
                openDeliveryWidget={this.openDeliveryWidget}
                setRedeemableItem={setRedeemableItem}
              />

              <LoyaltyRedeem
                points={loyaltyPoints}
                openDeliveryWidget={this.openDeliveryWidget}
                setRedeemableItem={setRedeemableItem}
              />
            </div>
            <div id="deliveryPickUpWidget">
              {showDeliveryWidget ? (
                <DeliveryPickUpWidget
                  onClose={this.onCloseWidget}
                  onAddressType={address => {
                    this.setState({
                      addressType: address
                    });
                  }}
                  addressType={addressType}
                  analyticsPageSection="Nav"
                />
              ) : null}
            </div>
          </>
        )}
      </div>
    );
  }
}

LoyaltyReward.propTypes = {
  history: PropTypes.shape().isRequired,
  userAddress: PropTypes.string,
  loyaltyPoints: PropTypes.number,
  platformWalletLoyaltyCardFeature: PropTypes.bool,
  setRedirectUrl: PropTypes.func.isRequired,
  activeLoyalty: PropTypes.string,
  loyaltyRedeemables: PropTypes.arrayOf(PropTypes.shape()),
  setModalObject: PropTypes.func.isRequired,
  userOrderMethod: PropTypes.string,
  setRedeemableItem: PropTypes.func,
  order: PropTypes.shape(),
};

LoyaltyReward.defaultProps = {
  userAddress: null,
  loyaltyPoints: null,
  platformWalletLoyaltyCardFeature: false,
  activeLoyalty: null,
  loyaltyRedeemables: null,
  userOrderMethod: null,
  setRedeemableItem: () => {},
  order: null
};

export const mapStateToProps = state => {
  const { userAddress, userCart, userOrderMethod } = state.user;
  const {
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    activeLoyalty,
    platformWalletLoyaltyCardFeature
  } = state.loyalty;
  return {
    ...(isBrandRefreshEnabled() ? { order: state.order } : {}),
    userAddress,
    userCart,
    loyaltyRedeemables,
    loyaltyDeals,
    loyaltyPoints,
    activeLoyalty,
    platformWalletLoyaltyCardFeature,
    userOrderMethod
  };
};

export const mapDispatchToProps = dispatch => ({
  setRedirectUrl: value => dispatch(addressActions.setRedirectUrl(value)),
  setModalObject: value => dispatch(elementsActions.setModalObject(value)),
  setRedeemableItem: value => dispatch(loyaltyAction.setRedeemableItem(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoyaltyReward);
